import React from 'react';
import styles from './IconAndName.module.css';

const IconAndName = ({
  icon,
  title = 'Button',
  onClick,
  bgColor = 'Primary_Color',
}) => {
  const style = {
    backgroundColor: `var(--${bgColor})`,
  };

  return (
    <button className={styles.container} style={style} onClick={onClick}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.title}>{title}</span>
    </button>
  );
};

export default IconAndName;
